import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { AssetTransfer } from '../models/entities/asset-transfer';
import { AssetTransferRequest } from '../models/dto/asset-transfer-request';
import { AssetCall } from '../models/entities/asset-call';
import { AssetCallRequest } from '../models/dto/asset-call-request';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/product-category-entity';


@Injectable({
  providedIn: 'root'
})
export class AssetTransferService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { }

  
  //-----------------------------------------------------------------------------------------------------
  assetTransfersGet(
    assetOrderCode        : string,
    sourceBranchCode      : string, 
    destinationBranchCode : string,
    partnerCode           : string, 
    assetTransferType     : string, // Branch or Partner
    plInitial             : boolean, 
    plSent                : boolean, 
    plSemiReceived        : boolean,
    plReceived            : boolean,
    startDate?            : Date, 
    endDate?              : Date)  : Promise<AssetTransfer[]> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1   = assetOrderCode;
    request.strArg2   = sourceBranchCode;
    request.strArg3   = destinationBranchCode;
    request.strArg4   = partnerCode;
    request.strArg5   = assetTransferType;

    request.blnArg1 = plInitial;
    request.blnArg2 = plSent;
    request.blnArg3 = plSemiReceived;
    request.blnArg4 = plReceived;
    
    request.dteArg1   = startDate;
    request.dteArg2   = endDate;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetTransfersGet', request).then(result => {
          return resolve(result.assetTransfers);
        }, error => {
            reject(error);
        });
    });
  }


   
  assetTransferGet(assetTransferCode : string, allAssetProductsAsLines? : boolean) : Promise<AssetTransfer> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1   = assetTransferCode;
    request.blnArg1   = allAssetProductsAsLines;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetTransferGet', request).then(result => {
          let assetTransfer : AssetTransfer = result.assetTransfer;
          if (assetTransfer.assetTransferLines) {
            assetTransfer.assetTransferLines.forEach(assetTransferLine => {
              assetTransferLine.shrinkMode = true;
              });
          }
          return resolve(assetTransfer);
        }, error => {
            reject(error);
        });
    });
  }

  
  assetTransferLinkAssets(assetTransfer : AssetTransfer) : Promise<AssetTransfer> {
    let request           : AssetTransferRequest = new AssetTransferRequest(this.userService.userInfo);
    
    request.assetTransfer = assetTransfer;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetTransferLinkAssets', request).then(result => {
          let assetTransfer : AssetTransfer = result.assetTransfer;
          if (assetTransfer.assetTransferLines) {
            assetTransfer.assetTransferLines.forEach(assetTransferLine => {
              assetTransferLine.shrinkMode = true;
              });
          }
          return resolve(assetTransfer);
        }, error => {
            reject(error);
        });
    });
  }

  assetTransferSave(assetTransfer : AssetTransfer) : Promise<AssetTransfer> {
    let request           : AssetTransferRequest = new AssetTransferRequest(this.userService.userInfo);
    
    assetTransfer.updated = true;
    request.assetTransfer = assetTransfer;


    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetTransferSave', request).then(result => {
          let assetTransfer : AssetTransfer = result.assetTransfer;
          if (assetTransfer.assetTransferLines) {
            assetTransfer.assetTransferLines.forEach(assetTransferLine => {
              assetTransferLine.shrinkMode = true;
              });
          }
          return resolve(assetTransfer);
        }, error => {
            reject(error);
        });
    });
  }

  //-----------------------------------------------------------------------------------------------------
  
  assetTransferValidateReception(assetTransfer : AssetTransfer) : Promise<AssetTransfer> {
    let request           : AssetTransferRequest = new AssetTransferRequest(this.userService.userInfo);
    
    request.assetTransfer = assetTransfer;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetTransferValidateReception', request).then(result => {
          let assetTransfer : AssetTransfer = result.assetTransfer;
          if (assetTransfer.assetTransferLines) {
            assetTransfer.assetTransferLines.forEach(assetTransferLine => {
              assetTransferLine.shrinkMode = true;
              });
          }
          return resolve(assetTransfer);
        }, error => {
            reject(error);
        });
    });
  }


  

  assetTransferValidateExpedition(assetTransferCode : string) : Promise<AssetTransfer> {
    let request           : AssetTransferRequest = new AssetTransferRequest(this.userService.userInfo);

    request.strArg1       = assetTransferCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetTransferValidateExpedition', request).then(result => {
          let assetTransfer : AssetTransfer = result.assetTransfer;
          if (assetTransfer.assetTransferLines) {
            assetTransfer.assetTransferLines.forEach(assetTransferLine => {
              assetTransferLine.shrinkMode = true;
              });
          }
          return resolve(assetTransfer);
        }, error => {
            reject(error);
        });
    });
  }
  

  assetTransferRegisterReception(assetTransfer : AssetTransfer) : Promise<Boolean> {
    let request           : AssetTransferRequest = new AssetTransferRequest(this.userService.userInfo);
    request.assetTransfer = assetTransfer;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetTransferRegisterReception', request).then(result => {
          return resolve(result);
        }, error => {
            reject(error);
        });
    });
  }

  //-----------------------------------------------------------------------------------------------------
  

    //-----------------------------------------------------------------------------------------------------
    assetCallsGet(
              branchCode?          : string,
              clusterCode?         : string,
              productCategoryCode? : string, 
              partnerCode?         : string, 
              startDate?           : Date,
              endDate?             : Date, 
              progressLevel?       : number,
              assetTransferCode?   : string,
              contractCode?        : string) : Promise<AssetCall[]> {
      let request       : BaseRequest = new BaseRequest(this.userService.userInfo);

      request.strArg1   = branchCode;
      request.strArg2   = productCategoryCode;
      request.strArg3   = partnerCode;
      request.strArg4   = clusterCode;
      request.dteArg1   = startDate;
      request.dteArg2   = endDate;
      request.lngArg1   = progressLevel;
      request.strArg5   = assetTransferCode;
      request.strArg6   = contractCode;
      
      return new Promise((resolve, reject) => {
          this.networkService.post('services/logistics/assetCallsGet', request).then(result => {
            return resolve(result.assetCalls);
          }, error => {
              reject(error);
          });
      });
    }
  
    assetCallSave(assetCall : AssetCall) : Promise<AssetCall> {
      let request           : AssetCallRequest = new AssetCallRequest(this.userService.userInfo);
      
      assetCall.updated = true;
      request.assetCall = assetCall;
  
  
      return new Promise((resolve, reject) => {
          this.networkService.post('services/logistics/assetCallSave', request).then(result => {
            let assetCall : AssetCall = result.assetCall;
            return resolve(assetCall);
          }, error => {
              reject(error);
          });
      });
    }

    assetCallsCountGet(branchCode: string) : Promise<ProductCategory[]> {
      
      let request           : BaseRequest = new BaseRequest(this.userService.userInfo);
      request.strArg1 = branchCode;

      return new Promise((resolve, reject) => {
          this.networkService.post('services/logistics/assetCallsCountGet', request).then(result => {
            let productCategories : ProductCategory[] = result.productCategories;
            return resolve(productCategories);
          }, error => {
              reject(error);
          });
      });
    }
  


  assetAssetTransfersGet(assetCode : string) : Promise<AssetTransfer[]> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = assetCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetAssetTransfersGet', request).then(result => {
            return resolve(result.assetTransfers);  
        }, error => {
            reject(error);
        });
    });
  }


//-----------------------------------------------------------------------------------------------------
 //-----------------------------------------------------------------------------------------------------
}

